import { makeStyles, withStyles } from "@material-ui/core";
import MuiAccordion from "@material-ui/core/Accordion";
import zIndex from "@material-ui/core/styles/zIndex";


export const useStyles = makeStyles((theme) => ({
    base: {
        height: 48,
        "&.Mui-expanded": {
            minHeight: 48,
        },
    },
    divider: {
        borderTop: `1px solid ${theme.palette.grey[300]}`,
        margin: "5px 0",
    },
    filters: {
        display: "flex",
        flexDirection: "column",
    },
    filterCheckbox: {
        margin: "-5px 0px",
    },
    filterIcon: {
        width: "1.8rem",
        height: "1.8rem",
    },
    filterLabel: {
        color: theme.palette.grey[700],
        display: "flex",
        alignItems: "center",
        margin: "4px 0px",
        "& p": {
            marginLeft: "6px",
        },
    },
}));

export const Accordion = withStyles({
    root: {
        borderRadius: 2,
        bottom: 0,
        boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
        display: "flex",
        flexDirection: "column-reverse",
        left: "4.5rem",
        margin: "26px 10px",
        position: "fixed",
        zIndex: zIndex.appBar,
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            bottom: 0,
            left: "4.5rem",
            margin: "26px 10px",
            zIndex: zIndex.appBar,
        },
    },
    expanded: {},
})(MuiAccordion);
